import { Box, SxProps, Theme } from '@mui/material';

import { ChatBox } from './ChatBox';
import { InfoBox } from './InfoBox';

export const SolutionSessionContent = () => {
  return (
    <Box sx={container}>
      <Box sx={paddedBoxChatBox}>
        <ChatBox />
      </Box>
      <Box sx={divider} />
      <Box sx={paddedBoxInfoBox}>
        <InfoBox />
      </Box>
    </Box>
  );
};

const container: SxProps<Theme> = {
  display: 'flex',
  flex: 1,
  height: '100%',
  width: '100%',
  flexDirection: 'row',
  borderRadius: '8px',
  '@media (max-width: 900px)': {
    flexDirection: 'column',
    gap: '30px',
  },
};

const divider: SxProps<Theme> = {
  backgroundColor: 'red',
  width: '1px',
  marginLeft: '34px',
};

const paddedBoxChatBox: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '20px',
  marginBottom: '18px',
  paddingLeft: 4,
};

const paddedBoxInfoBox: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '20px',
  minWidth: '55%',
  marginBottom: '18px',
  paddingRight: 4,
};
